/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 11: Advanced: Combinations (Days 301-330)
 *
 * All named movements combined. Functional integration.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  aperto: {
    id: 'aperto',
    name: 'Aperto',
    name_pt: 'Aperto',
    sub: 'Press inward from the sides. Not upward.',
    sub_pt: 'Pressione para dentro dos lados. Não para cima.',
    level: 'Intermediate',
    zone: 'Side walls 0-3cm',
    color: '#A07080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Press the left and right walls of the pelvic floor gently toward each other. This is a horizontal movement, not an upward lift. Like pressing the walls of a narrow corridor from both sides.

Hold for the prescribed time. Release completely. The side walls should widen on the release.

Test: do this with your legs apart. If you feel it in your inner thighs, start again.

Picture it: closing elevator doors gently from left and right. Or pressing two book covers together from the sides. The book (your canal) gets narrower.`,
    inst_pt: `Sente com pés apoiados no chão.

Pressione as paredes esquerda e direita do assoalho suavemente uma em direção à outra. Isso é um movimento horizontal, não uma elevação. Como pressionar as paredes de um corredor estreito dos dois lados.

Segure pelo tempo prescrito. Solte completamente. As paredes laterais devem alargar na soltura.

Teste: faça com pernas abertas. Se sentir nas coxas internas, recomece.

Visualize: fechando portas de elevador suavemente da esquerda e direita. Ou pressionando duas capas de livro juntas dos lados. O livro (seu canal) fica mais estreito.`,
    breathe: 'Exhale to press inward. Inhale to release and widen.',
    breathe_pt: 'Expire para pressionar. Inspire para soltar e alargar.',
    timerCue: `Press in.
Hold.
Widen.`,
    timerCue_pt: `Pressione.
Segure.
Alargue.`,
    feel: 'A medial compression of the lateral walls. Distinct from the upward lift.',
    feel_pt: 'Uma compressão medial das paredes laterais. Distinto da elevação para cima.',
    avoid: 'Do not squeeze your inner thighs together. Do not bear down.',
    avoid_pt: 'Não aperte as coxas internas. Não faça força.',
    type: 'hold',
    sets: 10,
    hold: 10,
    relax: 5,
    rest: 0,
  },

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  onda: {
    id: 'onda',
    name: 'Onda',
    name_pt: 'Onda',
    sub: 'Front wall. Release. Back wall. Release. Alternate.',
    sub_pt: 'Parede frontal. Solte. Parede posterior. Solte. Alterne.',
    level: 'Intermediate',
    zone: 'Full floor 0-6cm',
    color: '#9A7080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Gently press the front wall of the pelvic floor inward for 2 seconds. Release completely.

Gently press the back wall inward for 2 seconds. Release completely.

Alternate front and back in a slow rocking rhythm. Each direction is a separate, deliberate movement with a full release between.

Build toward 1 second per direction as the distinction becomes clear.

Picture it: a seesaw. One side up while the other is down. The front and back walls should feel like two separate entities.`,
    inst_pt: `Sente com pés apoiados no chão.

Pressione suavemente a parede frontal do assoalho por 2 segundos. Solte completamente.

Pressione suavemente a parede posterior por 2 segundos. Solte completamente.

Alterne frente e trás num ritmo lento de balanço. Cada direção é um movimento separado e deliberado com soltura total entre.

Construa para 1 segundo por direção conforme a distinção fica clara.

Visualize: gangorra. Um lado sobe enquanto o outro desce. As paredes frontal e posterior devem parecer duas entidades separadas.`,
    breathe: 'Exhale to press each wall in. Inhale to release between directions.',
    breathe_pt: 'Expire para pressionar cada parede. Inspire para soltar entre direções.',
    timerCue: `Front wall.
Release.
Back wall.
Release.`,
    timerCue_pt: `Parede frontal.
Solte.
Parede posterior.
Solte.`,
    feel: 'Two distinct directions with a clear release between each.',
    feel_pt: 'Duas direções distintas com soltura clara entre cada.',
    avoid: 'Do not squeeze front and back simultaneously. Do not skip the release between directions.',
    avoid_pt: 'Não aperte frente e trás simultaneamente. Não pule a soltura entre direções.',
    type: 'alt',
    sets: 19,
    hold: 2,
    relax: 2,
    rest: 0,
    altA: 'Front wall',
    altA_pt: 'Parede frontal',
    altB: 'Back wall',
    altB_pt: 'Parede posterior',
  },

  ordenha_ascend: {
    id: 'ordenha_ascend',
    name: 'Ordenha Ascending',
    name_pt: 'Ordenha Ascendente',
    sub: 'Level 1. Add Level 2. Add Level 3. Do not skip.',
    sub_pt: 'Nível 1. Adicione Nível 2. Adicione Nível 3. Não pule.',
    level: 'Intermediate',
    zone: 'Full floor 0-10cm',
    color: '#A07080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

CLOSE and SQUEEZE at Level 1 (the entrance). Hold.

Without releasing Level 1, add Level 2, imagine the contraction moving one floor deeper. Hold both.

Without releasing, add Level 3, the deepest accessible point. Hold all three levels together.

Release completely from base to Level 1. That is one rep.

If Level 3 is not yet clear, stop at Level 2. The depth develops with repetition.

Picture it: an elevator rising one floor at a time. Each level should feel distinct.`,
    inst_pt: `Sente com pés apoiados no chão.

FECHE e APERTE no Nível 1 (a entrada). Segure.

Sem soltar o Nível 1, adicione Nível 2, imagine a contração subindo um andar. Segure ambos.

Sem soltar, adicione Nível 3, o ponto mais profundo acessível. Segure os três níveis.

Solte completamente da base ao Nível 1. Isso é uma repetição.

Se Nível 3 ainda não estiver claro, pare no Nível 2. A profundidade se desenvolve com repetição.

Visualize: elevador subindo um andar de cada vez. Cada nível deve parecer distinto.`,
    breathe: 'Exhale to CLOSE and SQUEEZE at Level 1. Continue exhaling as you layer in Level 2 and Level 3.',
    breathe_pt: 'Expire para FECHAR e APERTAR no Nível 1. Continue expirando conforme adiciona Nível 2 e Nível 3.',
    timerCue: `Level 1.
Add Level 2.
Add Level 3.
Release.`,
    timerCue_pt: `Nível 1.
Adicione Nível 2.
Adicione Nível 3.
Solte.`,
    feel: 'A sequential layering sensation. Like an elevator rising one floor at a time. Each level should feel distinct.',
    feel_pt: 'Uma sensação de camadas sequenciais. Como elevador subindo um andar de cada vez. Cada nível deve parecer distinto.',
    avoid: 'Do not skip levels to reach Level 3. Do not bear down. Do not hold your breath at any level.',
    avoid_pt: 'Não pule níveis para chegar ao Nível 3. Não faça força. Não prenda respiração em nenhum nível.',
    type: 'hold',
    sets: 10,
    hold: 8,
    relax: 8,
    rest: 0,
  },

  standing_squeeze: {
    id: 'standing_squeeze',
    name: 'Standing Squeeze',
    name_pt: 'Aperto em Pé',
    sub: 'Squeeze against gravity. Standing is harder.',
    sub_pt: 'Aperte contra a gravidade. Em pé é mais difícil.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. No wall support.

CLOSE and SQUEEZE at 60% for 5 seconds. Release for 5 seconds.

Standing squeezes are harder because gravity pulls on organs. If you cannot hold 5 seconds standing, reduce to 3.

Picture it: an invisible hand gently lifting your pelvic floor from below while you stand. The hand holds for 5 seconds, then lets go.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Sem apoio.

FECHE e APERTE em 60% por 5 segundos. Solte por 5 segundos.

Apertos em pé são mais difíceis porque gravidade puxa órgãos. Se não conseguir segurar 5 segundos, reduza para 3.

Visualize: uma mão invisível levantando suavemente seu assoalho de baixo enquanto está de pé. A mão segura 5 segundos, depois solta.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Hold.
Release.`,
    timerCue_pt: `Aperte.
Segure.
Solte.`,
    feel: 'Lift against gravity. The floor working with more effort to rise upward.',
    feel_pt: 'Elevação contra a gravidade. O assoalho trabalhando com mais esforço para subir.',
    avoid: 'Do not lock knees. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não trave joelhos. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  vibracao: {
    id: 'vibracao',
    name: 'Vibração',
    name_pt: 'Vibração',
    sub: 'Pulsação from deeper inside. If depth retreats, stop and reset.',
    sub_pt: 'Pulsação de mais fundo. Se profundidade recuar, pare e reinicie.',
    level: 'Advanced',
    zone: 'Full floor 3-6cm',
    color: '#7A5060',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Bring your awareness to Level 2, the central zone. Establish your sense of this depth before beginning.

From Level 2, CLOSE and SQUEEZE for 1 second. Release completely from Level 2 for 1 second. Repeat in rhythm.

If you feel the movement retreating to the entrance, stop. Do 3 Gentle Pushes to reset to Level 2. Begin the next set from depth.

After each set: 3 slow Gentle Pushes confirm the floor has returned to Level 2 rest.

Picture it: the same clean on-off rhythm as Pulsação, but felt deeper inside. Like a heartbeat in your center rather than at the surface.`,
    inst_pt: `Sente com pés apoiados no chão.

Leve sua consciência ao Nível 2, a zona central. Estabeleça sua sensação dessa profundidade antes de começar.

Do Nível 2, FECHE e APERTE por 1 segundo. Solte completamente do Nível 2 por 1 segundo. Repita em ritmo.

Se sentir o movimento recuando à entrada, pare. Faça 3 Empurrões Suaves para resetar ao Nível 2. Comece a próxima série da profundidade.

Após cada série: 3 Empurrões Suaves lentos confirmam que o assoalho voltou ao repouso do Nível 2.

Visualize: o mesmo ritmo liga-desliga limpo da Pulsação, mas sentido mais fundo. Como um batimento cardíaco no seu centro em vez da superfície.`,
    breathe: 'Exhale to CLOSE and SQUEEZE at depth. Inhale to release from depth.',
    breathe_pt: 'Expire para FECHAR e APERTAR na profundidade. Inspire para soltar da profundidade.',
    timerCue: `Level 2.
Squeeze.
Release.`,
    timerCue_pt: `Nível 2.
Aperte.
Solte.`,
    feel: 'A clean on-off rhythm felt deeper inside the pelvic floor.',
    feel_pt: 'Um ritmo limpo de liga-desliga sentido mais fundo no assoalho pélvico.',
    avoid: 'Do not continue if depth retreats to Level 1. Stop and reset. Do not bear down.',
    avoid_pt: 'Não continue se profundidade recuar ao Nível 1. Pare e reinicie. Não faça força.',
    type: 'pulse',
    sets: 4,
    rest: 15,
    reps: 15,
    on: 1,
    off: 1,
  },
};

export const days = [
  {
    day: 301, week: 43,
    title: 'Day 301', title_pt: 'Dia 301',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 302, week: 44,
    title: 'Day 302', title_pt: 'Dia 302',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 303, week: 44,
    title: 'Day 303', title_pt: 'Dia 303',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'onda', overrides: {"sets": 38} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 304, week: 44,
    title: 'Day 304', title_pt: 'Dia 304',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 305, week: 44,
    title: 'Day 305', title_pt: 'Dia 305',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'onda', overrides: {"sets": 38} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 306, week: 44,
    title: 'Day 306', title_pt: 'Dia 306',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 307, week: 44,
    title: 'Day 307', title_pt: 'Dia 307',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
      { ref: 'belly_breath_drop', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 308, week: 44,
    title: 'Day 308', title_pt: 'Dia 308',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'vibracao', overrides: {} }, // 165s
    ], // Total: 315s = 5.2 min
  },
  {
    day: 309, week: 45,
    title: 'Day 309', title_pt: 'Dia 309',
    exercises: [
      { ref: 'onda', overrides: {"sets": 38} }, // 152s
      { ref: 'child_pose_release', overrides: {"hold": 148} }, // 148s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 310, week: 45,
    title: 'Day 310', title_pt: 'Dia 310',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'child_pose_release', overrides: {"hold": 95} }, // 95s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 311, week: 45,
    title: 'Day 311', title_pt: 'Dia 311',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'onda', overrides: {"sets": 38} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 312, week: 45,
    title: 'Day 312', title_pt: 'Dia 312',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 313, week: 45,
    title: 'Day 313', title_pt: 'Dia 313',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'onda', overrides: {"sets": 38} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 314, week: 45,
    title: 'Day 314', title_pt: 'Dia 314',
    exercises: [
      { ref: 'vibracao', overrides: {} }, // 165s
      { ref: 'onda', overrides: {"sets": 34} }, // 136s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 315, week: 45,
    title: 'Day 315', title_pt: 'Dia 315',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 316, week: 46,
    title: 'Day 316', title_pt: 'Dia 316',
    exercises: [
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 305s = 5.1 min
  },
  {
    day: 317, week: 46,
    title: 'Day 317', title_pt: 'Dia 317',
    exercises: [
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 318, week: 46,
    title: 'Day 318', title_pt: 'Dia 318',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'vibracao', overrides: {} }, // 165s
    ], // Total: 315s = 5.2 min
  },
  {
    day: 319, week: 46,
    title: 'Day 319', title_pt: 'Dia 319',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'vibracao', overrides: {} }, // 165s
    ], // Total: 315s = 5.2 min
  },
  {
    day: 320, week: 46,
    title: 'Day 320', title_pt: 'Dia 320',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'vibracao', overrides: {} }, // 165s
    ], // Total: 315s = 5.2 min
  },
  {
    day: 321, week: 46,
    title: 'Day 321', title_pt: 'Dia 321',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 322, week: 46,
    title: 'Day 322', title_pt: 'Dia 322',
    exercises: [
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 323, week: 47,
    title: 'Day 323', title_pt: 'Dia 323',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 324, week: 47,
    title: 'Day 324', title_pt: 'Dia 324',
    exercises: [
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
    ], // Total: 305.0s = 5.1 min
  },
  {
    day: 325, week: 47,
    title: 'Day 325', title_pt: 'Dia 325',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 326, week: 47,
    title: 'Day 326', title_pt: 'Dia 326',
    exercises: [
      { ref: 'vibracao', overrides: {} }, // 165s
      { ref: 'ordenha_ascend', overrides: {"sets": 8} }, // 128s
    ], // Total: 293s = 4.9 min
  },
  {
    day: 327, week: 47,
    title: 'Day 327', title_pt: 'Dia 327',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 328, week: 47,
    title: 'Day 328', title_pt: 'Dia 328',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 329, week: 47,
    title: 'Day 329', title_pt: 'Dia 329',
    exercises: [
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 330, week: 48,
    title: 'Day 330', title_pt: 'Dia 330',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
];


export const monthMeta = {
  month: 11,
  program: 'release',
  phase: 'Advanced: Combinations',
  phase_pt: 'Avancado: Combinacoes',
  days_range: [301, 330],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}